const defaultProps = {
    disabled: {
        default: false,
        type: Boolean,
    },
    value: {

    },
    required: {
        default: false,
        type: Boolean
    },
    label: {
        type: String,
        default: ''
    },
    name: {
        type: String,
        required: true,
    },
    rules: {
        type: [String, Object],
        default: ''
    },
    vid: {
        type: String,
        required: true,
    },
    description: {
        default: undefined,
        type: String
    },
    prepend: {
        default: undefined,
        type: String,
    }
}

export const DefaultInputProps = {
    ...defaultProps,
    ltr: {
        default: undefined,
        type: Boolean,
    },
    type: {
        type: String,
        default: 'text',
    },
    placeholder: {
        type: String,
    }
}

export const DefaultSelectProps = {
    ...defaultProps,
    options: {
        required: true,
        type: Array
    }
}

export const DefaultInputFileProps = {
    ...defaultProps,
}